import styled, { css } from 'styled-components'

import { Image, PersonAvatar, WorkspaceLogo } from '@sketch/components'

import { PREVIEW_SIZE } from '../InboxListItem.styles'

const previewImage = css`
  /* --- rounded-rect bite for the overlapping badge (bottom-right) --- */
  --bite-w: 21px; /* badge width + gap on each side */
  --bite-h: 21px; /* badge height + gap on each side */
  --bite-x: -6px; /* inset from the right edge */
  --bite-y: -6px; /* inset from the bottom edge */
  /* corner radius is baked into the SVG below (rx) */

  width: ${PREVIEW_SIZE}px;
  height: ${PREVIEW_SIZE}px;
  border-radius: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.tertiary.C};
  box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.background.tertiary.C};

  -webkit-mask:
    linear-gradient(#000 0 0),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='19'%3E%3Crect width='19' height='19' rx='7' fill='black'/%3E%3C/svg%3E")
      right var(--bite-x) bottom var(--bite-y) / var(--bite-w) var(--bite-h)
      no-repeat;
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#000 0 0),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='19'%3E%3Crect width='19' height='19' rx='7' fill='black'/%3E%3C/svg%3E")
      right var(--bite-x) bottom var(--bite-y) / var(--bite-w) var(--bite-h)
      no-repeat;
  mask-composite: exclude;
`

export const SubjectPreviewImage = styled(Image).attrs({
  objectFit: 'contain',
})`
  ${previewImage}
`

export const SubjectFolderGrid = styled.div`
  position: relative;
  box-sizing: border-box;

  padding: 2px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 2px;

  ${previewImage}
`

export const SubjectFolderTile = styled.div`
  min-width: 0;
  min-height: 0;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.secondary.C};
`

export const SubjectFolderImage = styled(Image)`
  width: 100%;
  height: 100%;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border: 1px solid ${({ theme }) => theme.colors.border.A};
    border-radius: 6px;
    box-sizing: border-box;
    pointer-events: none;
  }
`

export const SubjectFolderIcon = styled.div`
  width: 12px;
  height: 12px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  opacity: 0.3;

  > svg {
    width: 12px;
    height: 12px;
    display: block;
  }
`

export const SubjectWorkspaceLogo = styled(WorkspaceLogo)`
  ${previewImage}

  &::after {
    border-radius: 8px;
    border: none;
  }
`

export const SubjectPersonAvatar = styled(PersonAvatar)`
  ${previewImage}

  background: none;
`
